import { createSelector } from '@reduxjs/toolkit';

import { IGlobalState } from 'app/models';
import { options, utils } from './options';

export const getLookup = createSelector(
  ({ lookup }: IGlobalState, key: string) => lookup?.[key],
  (_: IGlobalState, key: string) => options[utils.decode(key)[0]],
  (data, opts) => data?.map(opts.map),
);
